import type { OpeningMetrics } from "~/lib/objects";

export function formatOpeningMetrics(
  metrics: OpeningMetrics | null | undefined,
): string {
  if (!metrics) {
    return "-";
  }

  return `${metrics.totalMoves} / ${metrics.forkCount} / ${metrics.terminalPositionCount}`;
}
